import { useLocalization } from '@magicdoor/ui';
import { useNavigate } from '@solidjs/router';
import IconReturn from '~/assets/auth/return.svg?component-solid';
import { Button } from '~/components/common/Buttons/Button';

interface ReturnToLoginProps {
  toPreviousStep?: () => void;
}

export const ReturnButton = (props: ReturnToLoginProps) => {
  const { t } = useLocalization();
  const navigate = useNavigate();

  const handleClick = () => {
    if (props.toPreviousStep) {
      props.toPreviousStep();
    } else {
      navigate('/auth/signin');
    }
  };

  return (
    <Button rounded="full" type="button" class="flex justify-center" variant="outlined" onClick={handleClick}>
      <IconReturn />
      {props.toPreviousStep ? t('Return to last step') : t('Return to login')}
    </Button>
  );
};
